import { MONK_V3 } from '../../../../../config/constants';

const BASE = `${MONK_V3}/admin/rbac`;

const extractPayload = response =>
  response?.data ?? response?.result ?? response;

export const rbacApi = {
  getRbacUsers: callApi => callApi('GET', `${BASE}/users`).then(extractPayload),

  getRbacFlags: callApi => callApi('GET', `${BASE}/flags`).then(extractPayload),

  getRbacAccess: callApi =>
    callApi('GET', `${BASE}/access`).then(extractPayload),

  saveRbacAccess: (callApi, payload) =>
    callApi('POST', `${BASE}/access`, payload).then(extractPayload),

  getLoggedInUserAccess: callApi =>
    callApi('GET', `${BASE}/get-logged-in-user-access`).then(extractPayload),
};
